export const widgetCardMinWidth = 630;
export const widgetCardsGap = 20;
